export default "__VITE_ASSET__$1s8l6xM__"